import {FETCH_DSA_OEM_ADMIN_URL_REQUEST, FETCH_DSA_OEM_ADMIN_URL_SUCCESS, FETCH_DSA_OEM_ADMIN_URL_FAILURE, DELETE_DSA_OEM_ADMIN_URL_REQUEST, DELETE_DSA_OEM_ADMIN_URL_SUCCESS, DELETE_DSA_OEM_ADMIN_URL_FAILURE, CHECK_EUROPEAN_COUNTRIES, CHECK_TAG_COUNTRIES, UPDATE_TARGETING_TAGS} from "./DSAOemAdminUrlTypes";

const initialState = {
  loading: false,
  DSAComplaintData: {},
  isEuropeanCountry: false,
  checkTagCountries:[],
  updatedTargetingTags: [],
  error: null,
};

 const DSAOemAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DSA_OEM_ADMIN_URL_REQUEST: 
    case DELETE_DSA_OEM_ADMIN_URL_REQUEST:
        return {    
            ...state,
            loading: true,
            error: null,            
        };
    case FETCH_DSA_OEM_ADMIN_URL_SUCCESS:
        return {    
            ...state,
            loading: false,
            DSAComplaintData: action.payload || {}, 
            error: null,            
        };
    case FETCH_DSA_OEM_ADMIN_URL_FAILURE:
    case DELETE_DSA_OEM_ADMIN_URL_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };          

    case DELETE_DSA_OEM_ADMIN_URL_SUCCESS:  
        return {    
            ...state,
            loading: false,
            DSAComplaintData: state.DSAComplaintData,
            error: null,
        };  
    case CHECK_EUROPEAN_COUNTRIES:
        return{
            ...state,
            isEuropeanCountry: action.payload,

        };
    case CHECK_TAG_COUNTRIES:
        return{
            ...state,
            checkTagCountries: action.payload,
        }
    case UPDATE_TARGETING_TAGS:
        return{
            ...state,
            updatedTargetingTags: action.payload,
        }
    default:
      return state;
  }   
} 

export default DSAOemAdminReducer;